import styles from "./SectionAboutUs.module.css";
import aboutUsBgImage from "../../assets/images/somos/lineas (1).png";
import aboutUsIcon33 from "../../assets/images/somos/Group 33.png";
import aboutUsIcon34 from "../../assets/images/somos/Group 34.png";
import aboutUsIcon35 from "../../assets/images/somos/Group 35.png";
import SectionTemplate from "../../templates/SectionTemplate";

const SectionAboutUs = () => {
  return (
    <SectionTemplate>
      <section
        className={styles.section}
        style={{
          backgroundImage: `url(${aboutUsBgImage})`,
        }}
      >
        <h2 className={styles.title}>Más sobre nosotros</h2>

        <div className={styles.cardsContainer}>
          {/* Misión */}
          <div className={styles.card}>
            <img src={aboutUsIcon34} alt="Misión" className={styles.icon} />
            <h3 className={styles.cardTitle}>Misión</h3>
            <p className={styles.cardText}>
              Ser un medio de enlace seguro entre el proveedor y el
              transportista.
            </p>
          </div>

          {/* Visión */}
          <div className={styles.card}>
            <img src={aboutUsIcon35} alt="Visión" className={styles.icon} />
            <h3 className={styles.cardTitle}>Visión</h3>
            <p className={styles.cardText}>
              Crear una red de información útil para las empresas que requieran
              nuestros servicios.
            </p>
          </div>

          {/* Valores */}
          <div className={styles.card}>
            <img src={aboutUsIcon33} alt="Valores" className={styles.icon} />
            <h3 className={styles.cardTitle}>Valores</h3>
            <p className={styles.cardText}>
              Confianza <br />
              Seguridad <br />
              Credibilidad
            </p>
          </div>
        </div>

        <div className={styles.decorativeBox}></div>
      </section>
    </SectionTemplate>
  );
};

export default SectionAboutUs;
